import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "guide-control-component-body g-bl" }
const _hoisted_2 = { class: "guide-control-component-body-content" }
const _hoisted_3 = { class: "gb-font" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "name gb-font" }
const _hoisted_7 = { class: "miaoshu" }

import GuideMenuButtonVO from '@/ts/vo/GuideMenuButtonVO';
import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'GuideControlComponent',
  setup(__props, { expose: __expose }) {

const title = ref<string>("");
const buttonMenus = ref<GuideMenuButtonVO[]>([]);
const show = ref(false);

/**
 * 显示
 * @param _title 标题
 * @param _buttonMenus 按钮列表 
 */
function Show(_title: string, _buttonMenus: GuideMenuButtonVO[]) {
    title.value = _title;
    buttonMenus.value = _buttonMenus;
    show.value = true;
}

/**
 * 隐藏
 */
function Hide() {
    show.value = false;
}
/**
 * 关闭
 */
function Close() {
    Hide();
}

__expose({
    Show,
    Hide
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "guanbi-box" }, [
        _createElementVNode("i", {
          class: "iconfont ad-guanbi guanbi-btn",
          onClick: Close
        })
      ]),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(title.value), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buttonMenus.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "guide-item gb-card-select",
          onClick: item.action
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(item.miaoshu), 1)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "right" }, [
            _createElementVNode("i", { class: "item-icon iconfont ad-arrow-right-s-line" })
          ], -1))
        ], 8, _hoisted_4))
      }), 256))
    ])
  ], 512)), [
    [_vShow, show.value]
  ])
}
}

})